<template>
  <section>
    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.SIGNED)"
      type="is-white"
      multilined
      :always="showTooltip[DOC_SIGN.SIGNED]"
      class="list-sign"
      size="is-large"
      :position="tooltipPosition"
    >
      <div
        data-cy="SIGNED_BUTTON"
        class="circle signed"
        @mouseover="setShowTooltip(DOC_SIGN.SIGNED, true)"
        @mousemove="setShowTooltip(DOC_SIGN.SIGNED, false)"
      ></div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.SIGNED, false)"
          @mousemove="setShowTooltip(DOC_SIGN.SIGNED, true)"
        >
          <span class="has-text-weight-semibold">{{
            General.SIGNATURE_STATES
          }}</span>
          <div
            v-for="(item, index) in processFileSign(DOC_SIGN.SIGNED)"
            :key="item.user_id"
            :class="item.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span class="flex-1 has-text-left">
              {{
                `${item.user_name} (${capacityFormatted(item.capacity)})${
                  processFileSignCount(DOC_SIGN.SIGNED) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.SIGNED).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
          </div>
          <div
            v-if="showRemoveOption"
            class="action-signature is-justify-content-flex-end"
          >
            <span
              class="has-text-weight-semibold mt-5 is-clickable"
              @click="removeSignatureModal()"
              >{{ General.REMOVE_ALL }}</span
            >
          </div>
        </section>
      </template>
    </b-tooltip>

    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.PENDING)"
      type="is-white"
      multilined
      :always="showTooltip[DOC_SIGN.PENDING]"
      class="list-sign"
      size="is-large"
      :position="tooltipPosition"
    >
      <div
        class="circle pending"
        @mouseover="setShowTooltip(DOC_SIGN.PENDING, true)"
        @mousemove="setShowTooltip(DOC_SIGN.PENDING, false)"
      ></div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.PENDING, false)"
          @mousemove="setShowTooltip(DOC_SIGN.PENDING, true)"
        >
          <span class="has-text-weight-semibold">{{
            General.SIGNATURE_STATES
          }}</span>
          <div
            v-for="(signature, index) in processFileSign(DOC_SIGN.PENDING)"
            :key="signature.user_id"
            :class="signature.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span class="flex-1 has-text-left">
              {{
                `${signature.user_name} (${capacityFormatted(
                  signature.capacity
                )})${
                  processFileSignCount(DOC_SIGN.PENDING) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.PENDING).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
            <span
              v-if="isOwner"
              class="is-clickable"
              @click="cancelSignatureModal(signature)"
            >
              <b-icon icon="delete" type="is-blue-oil" />
            </span>
          </div>
          <div v-if="isOwner" class="action-signature">
            <span
              class="has-text-weight-semibold mt-5 is-clickable"
              @click="cancelSignatureModal(false, DOC_SIGN.PENDING)"
              >{{ General.REMOVE_ALL }}</span
            >
          </div>
        </section>
      </template>
    </b-tooltip>

    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.REFUSED)"
      type="is-white"
      multilined
      :always="showTooltip[DOC_SIGN.REFUSED]"
      class="list-sign"
      size="is-large"
      :position="tooltipPosition"
    >
      <div
        class="circle refused"
        @mouseover="setShowTooltip(DOC_SIGN.REFUSED, true)"
        @mousemove="setShowTooltip(DOC_SIGN.REFUSED, false)"
      ></div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.REFUSED, false)"
          @mousemove="setShowTooltip(DOC_SIGN.REFUSED, true)"
        >
          <span class="has-text-weight-semibold">{{
            General.SIGNATURE_STATES
          }}</span>
          <div
            v-for="(item, index) in processFileSign(DOC_SIGN.REFUSED)"
            :key="item.user_id"
            :class="item.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span class="flex-1 has-text-left">
              {{
                `${item.user_name} (${capacityFormatted(item.capacity)})${
                  processFileSignCount(DOC_SIGN.REFUSED) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.REFUSED).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
          </div>
          <div v-if="isOwner" class="action-signature">
            <span
              class="has-text-weight-semibold mt-5 is-clickable"
              @click="cancelSignatureModal(false, DOC_SIGN.REFUSED)"
              >{{ General.DELETE }}</span
            >
            <span
              class="has-text-weight-semibold mt-5 is-clickable"
              @click="resendSignatureModal(false, DOC_SIGN.REFUSED)"
              >{{ General.REQUEST_AGAIN }}</span
            >
          </div>
        </section>
      </template>
    </b-tooltip>
  </section>
</template>

<script>
import { DOC_SIGNATURES_STATUS as DOC_SIGN } from "@/utils/enumerate";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { General } from "@/utils/constants";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SubscriptionHistoryView",
  props: {
    signHistory: {
      type: Array,
      default: () => []
    },
    processId: {
      type: String,
      required: true,
      default: null
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    tooltipPosition: {
      type: String,
      default: "is-top"
    }
  },
  data() {
    return {
      General,
      DOC_SIGN,
      documentsSelectedSignRequested: [],
      showTooltip: {
        REFUSED: false,
        PENDING: false,
        SIGNED: false
      }
    };
  },
  computed: {
    ...mapGetters(["isContrast", "isMobile", "getCapacityFormatted"]),
    showRemoveOption() {
      return !this.$route.path.includes("documentos-doe");
    }
  },
  methods: {
    ...mapActions({
      processFileRequest: "processFileRequest",
      cancelSignatureFile: "cancelSignatureFileRequest",
      deleteSignatures: "deleteSignatureFile",
      requestProcessFiles: "processFilesFilteredRequest"
    }),

    signatureHistoryType(type) {
      return this.signHistory.length
        ? this.signHistory.filter(
            signature => signature.status === type && !signature.only_historical
          )
        : [];
    },

    processFileSignCount(type) {
      return this.signatureHistoryType(type).length;
    },

    processFileSign(type) {
      return this.signatureHistoryType(type).slice(0, 4);
    },

    async cancelRequest() {
      this.isLoading = true;
      const list_signature_cancel = this.documentsSelectedSignRequested.map(
        signature => ({
          signature_file_id: signature.id
        })
      );
      await this.cancelSignatureFile(list_signature_cancel);
      await this.requestProcessFiles({
        files_id: this.documentsSelectedSignRequested.map(file => file.id),
        process: this.processId,
        processId: this.processId
      });
      this.isLoading = false;
    },

    async cancelSignatureModal(signature = null, type = null) {
      if (signature?.id) this.documentsSelectedSignRequested = [signature];
      else if (type)
        this.documentsSelectedSignRequested = this.signatureHistoryType(type);

      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${this.General.TEXTS.CONFIRM_CANCEL_REQUEST}?`,
          confirm: () => this.cancelRequest(),
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },

    setShowTooltip(type, state) {
      this.showTooltip[type] = state;
    },

    removeSignatureModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: `${this.General.WARNING}!`,
          message: `${this.General.TEXTS.DELETE_SIGNED_REQUEST}?`,
          confirm: async () => {
            this.isLoading = true;
            await this.deleteSignatures({
              processFileId: this.documentId,
              processId: this.processId
            });
            await this.processFileRequest({ processId: this.processId });
            this.isLoading = false;
          },
          buttons: [
            { label: General.YES, isConfirm: false, action: true },
            { label: General.NO, isConfirm: true, action: false }
          ]
        },
        hasModalCard: true,
        trapFocus: true
      });
    },
    capacityFormatted(capacity_id) {
      return capacity_id
        ? this.getCapacityFormatted(capacity_id)
        : General.EXTERNAL_USER;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.container-attached-doc {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: #ccc;
}

.custom-ph-8 {
  padding: 0 8px;
}

.pre-wrap {
  border-bottom: 1px solid $grey-lighter;
  white-space: pre-wrap;
}

.actions-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
}

.list-sign div {
  display: flex;
  align-items: center;
}

.list-sign div.pending > div > div,
.list-sign div.signed > div > div,
.list-sign div.refused > div > div,
.circle {
  border-radius: 50%;
  height: 8px;
  width: 8px;
  margin-right: 5px;
}

.list-sign div.pending > div > div,
.circle.pending {
  background-color: $pending-color;
}

.list-sign div.signed > div > div,
.circle.signed {
  background-color: $primary;
}

.list-sign div.refused > div > div,
.circle.refused {
  background-color: $refused-color;
}

.circle {
  height: 12px;
  width: 12px;
  cursor: pointer;
}

.list-sign .tooltip-content {
  background-color: red !important;
  color: blue !important;
}

.container-new {
  text-align: left;
  color: #000;
  font-weight: 300;
}

.handler {
  cursor: move;
  opacity: 0;
}

.container-attached-doc:hover .handler {
  opacity: 1;
}

.tooltip-container {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}

.action-signature {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid $border-color;
  margin-top: 5px;
  color: $blue-oil;
}
</style>
